import { SESSION_MY_STORE_STRING } from '@hooks/useMyStore'
import { removeLocalStorage } from '@helpers/storage'

// Actions
export const SET_MY_STORE = 'SET_MY_STORE'
export const REMOVE_MY_STORE = 'REMOVE_MY_STORE'

// Action Creators
export function setMyStore(myStore) {
  return { type: SET_MY_STORE, myStore }
}

export function removeMyStore() {
  return { type: REMOVE_MY_STORE }
}

// Reducer
const initialState = {
  myStore: {},
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MY_STORE:
      return {
        ...state,
        myStore: action.myStore,
      }
    case REMOVE_MY_STORE:
      removeLocalStorage(SESSION_MY_STORE_STRING)
      return {
        ...state,
        myStore: {},
      }
    default:
      return state
  }
}
